/*
 * File: useRoutingBlocker.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 21, 2025 at 10:42 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 26, 2025 at 5:27 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import {
	useContext, useEffect, useCallback
} from 'react';
import {
	UNSAFE_NavigationContext as NavigationContext
} from 'react-router-dom';


/**
 * Hooks
 */

export function useBlocker(blocker, when = true) {
	const { navigator } = useContext(NavigationContext);
	useEffect(() => {
		if (!when) return;
		const unblock = navigator.block((tx) => {
			const autoUnblockingTx = {
				...tx,
				retry() {

					// Automatically unblock the transition so it can play all the way
					// through before retrying it. WIP: Figure out how to re-enable
					// this block if the transition is cancelled for some reason.
					unblock();
					tx.retry();
				},
			};
			blocker(autoUnblockingTx);
		});
		// eslint-disable-next-line consistent-return
		return unblock;
	}, [navigator, blocker, when]);
}

export function useRoutingBlocker(message, when = true) {
	const blocker = useCallback(
		(tx) => {
			// eslint-disable-next-line no-alert
			if (window.confirm(message)) tx.retry();
		},
		[message]
	);
	useBlocker(blocker, when);
}
